export const build = { date:"2026-07-03.1125", stage:"alpha" }
